import { useMemo } from 'react';

interface VocalGuideProps {
    text: string;
}

// 공백을 span 태그로 변환하여 너비를 넓게 설정
const processSpaces = (text: string, keyPrefix: string): React.ReactNode[] => {
    const parts: React.ReactNode[] = [];
    let keyIndex = 0;

    text.split(/(\s+)/).forEach((part, index) => {
        if (part.trim() === '') {
            // 공백인 경우 각 공백 문자마다 span으로 변환
            for (let i = 0; i < part.length; i++) {
                parts.push(
                    <span key={`${keyPrefix}-space-${keyIndex++}`} className="inline-block w-2" />,
                );
            }
        } else {
            parts.push(part);
        }
    });

    return parts;
};

// vocalGuide 텍스트를 파싱해서 **강세** 부분을 bold + 크게 렌더링
const parseVocalGuide = (text: string): React.ReactNode[] => {
    // 대괄호로 묶여있지 않으면 추가
    let processedText = text.trim();
    if (!processedText.startsWith('[') || !processedText.endsWith(']')) {
        processedText = `[${processedText}]`;
    }

    // 시작과 끝의 대괄호를 제외한 내부 대괄호 제거
    if (processedText.startsWith('[') && processedText.endsWith(']')) {
        const innerContent = processedText.slice(1, -1).replace(/[\\]/g, '');
        processedText = `[${innerContent}]`;
    }

    const parts: React.ReactNode[] = [];
    const segments = processedText.split(/(\*\*.+?\*\*)/g);

    segments.forEach((segment, index) => {
        if (!segment) return;

        const isBold = segment.startsWith('**') && segment.endsWith('**');
        if (isBold) {
            // ** 안의 강세 텍스트 (bold + 약간 크게)
            const boldText = segment.slice(2, -2);
            parts.push(
                <strong key={`bold-${index}`} className="font-semibold">
                    {processSpaces(boldText, `strong-${index}`)}
                </strong>,
            );
        } else {
            // 일반 텍스트
            parts.push(
                <span key={`normal-${index}`} className="text-[90%]">
                    {processSpaces(segment, `normal-${index}`)}
                </span>,
            );
        }
    });

    return parts;
};

const VocalGuide = ({ text }: VocalGuideProps) => {
    const parsedContent = useMemo(() => parseVocalGuide(text), [text]);

    return <span>{parsedContent}</span>;
};

export default VocalGuide;
